module.exports = __webpack_public_path__ + "NH_features_tools.7ae92e1c.svg";